export default "__VITE_ASSET__DiCGVE53__"